import React, { useContext } from "react";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import Button from "core/buttons/button/Button";
import "./ClientsToolsForm.scss";
import InputText from "core/inputs/input-text/InputText";
import InfoContext from "pages/InfoContext";
import { THREE_CHARACTERS_MINI } from "constants/popup-codes";
import { MISSION_STATUS_FILTERS, POPUP_STATUS } from "constants/constants";
import InputCheckList from "core/inputs/input-check-list/InputCheckList";

function ClientsToolsForm({ search }) {
  const {
    setCode,
    setStatus,
    clientsFilter,
    setClientsFilter,
    errors,
    setClientsMissionsStatus,
    clientsMissionsStatus,
    setClientsMissionsStatusFilter,
  } = useContext(InfoContext);

  const onError = () => {
    setStatus(POPUP_STATUS.ERROR);
    setCode(THREE_CHARACTERS_MINI);
  };

  const handleSubmit = () => {
    setClientsMissionsStatusFilter(clientsMissionsStatus);
    return clientsFilter.length < 3 ? onError() : search(clientsFilter);
  };

  return (
    <div className="clients-tools-wrapper">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="clients_tools"
            defaultMessage="RECHERCHER DES CLIENTS"
          />
        }
      />
      <div className="tool-txt">
        <FormattedMessage
          id="desc_mission_tools"
          defaultMessage="Minimum de 3 lettres pour effectuer votre recherche, ou d'un métier/secteur.
        La recherche est possible avec plusieurs mots clés. ( Le séparateur '|' est disponible pour améliorer votre recherche)"
        />
      </div>
      <div className="section-1">
        <div className="cell-padding">
          <InputText
            value={clientsFilter}
            errors={errors["client-title-filter"]}
            label={{
              id: "filter_clients_tools_title",
              defaultMessage: "Nom du client",
            }}
            placeholder={{
              id: "filter_clients_tools_placeholder",
            }}
            onChange={(e) => setClientsFilter(e.target.value)}
            id="client-title-filter"
            required
          />
        </div>
        <div className="cell-padding">
          <label className="label">
            <FormattedMessage
              id="filter_mission_tools_status"
              defaultMessage="Statut de la mission"
            />
          </label>
          <div className="checkList">
            <InputCheckList
              onChange={(vals) => {
                setClientsMissionsStatus(vals || []);
              }}
              value={clientsMissionsStatus}
              infoList={MISSION_STATUS_FILTERS}
              readOnly={false}
            />
          </div>
        </div>
      </div>
      <div className="div-buttons">
        <Button
          color="btn-medium gray-700"
          onClick={() => handleSubmit()}
          id="button-search"
        >
          <FormattedMessage
            id="search_clients_button_tools"
            defaultMessage="Rechercher les clients"
          />
        </Button>
      </div>
    </div>
  );
}

export default ClientsToolsForm;
